import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import Select from 'react-select';
import _actions from '../../actions';
import i18n from '../../i18n';
import ValidatedInput from '../../components/forms/ValidatedInput';
import TimePicker from '../../components/forms/TimePicker';
import Calendar from '../../components/svg/Calendar';
import Clock from '../../components/svg/Clock';
import LargeModal from '../modals/LargeModal';

class MessagesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            now: true,
            title: props.messages.subject,
            message: props.messages.body,
            pickerDown: false,
            format24: 'false',
            recipients: props.messages.formMessage,
            formId: props.messages.formId,
            formLabel: props.messages.formTitle,
        };

        this.closeDialog = this.closeDialog.bind(this);
    }

    componentDidMount() {
        if (window.innerHeight > 1000) {
            this.setState({ pickerDown: true });
        } else {
            this.setState({ pickerDown: false });
        }
        if (this.props.messages.formMessage) {
            this.setState({
                recipients: true,
            });
        }
        if (this.props.messages.scheduledTime) {
            this.setState({
                now: false,
                scheduleDateTimeObject: moment(`${this.props.messages.scheduledTime}Z`),
            });
        } else {
            this.setState({
                scheduleDateTimeObject: moment(),
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.now !== prevState.now
            // eslint-disable-next-line no-mixed-operators
            || this.state.scheduleDateTimeObject !== prevState.scheduleDateTimeObject
            // eslint-disable-next-line no-mixed-operators
            && this.state.scheduleDateTimeObject !== null) {
            if (!this.state.now && !this.state.scheduleDateTimeObject.isAfter(moment()
                .subtract(1, 'minutes'))
                && ((!this.props.messages.id && this.props.history) || (!this.props.history)
                )) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ timePastAlert: true });
            } else if ((!this.state.now
                && this.state.scheduleDateTimeObject.isAfter(moment()))
                || this.state.now) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ timePastAlert: false });
            }
        }
        if (this.state.value && !this.state.value.isValid()) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ value: null });
        }
        if (this.props.messages.scheduledTime !== prevProps.messages.scheduledTime) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                scheduleDateTimeObject: moment(`${this.props.messages.scheduledTime}Z`),
            });
        }
    }

    executeSave = () => {
        let subject;
        let body;
        let formId;
        let formTitle;
        if (this.state.title) {
            subject = this.state.title;
        } else {
            subject = this.props.messages.subject;
        }
        if (this.state.message) {
            body = this.state.message;
        } else {
            body = this.props.messages.body;
        }
        let scheduleTime = moment(this.state.scheduleDateTimeObject)
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss');
        if (this.state.now) {
            scheduleTime = moment()
                .utc()
                .format('YYYY-MM-DDTHH:mm:ss');
        }
        if (this.state.recipients) {
            formId = this.state.formId;
            formTitle = this.state.formLabel;
        }
        this.props.saveAction({
            subject,
            body,
            scheduleTime,
            id: this.props.messages.id,
            formMessage: this.state.recipients,
            formId,
            formTitle,
        });
        this.closeDialog();
    };

    handleTimeChange = (timeState, format24) => {
        let timeHour = timeState.hourValue;
        const timeMinute = timeState.minuteValue;
        if (format24 === 'true') {
            this.setState({ format24: 'true' });
        } else {
            if (timeState.am === 'am' && timeState.hourValue === '12') {
                timeHour = '00';
            } else if (timeState.am !== 'am' && timeState.hourValue !== '12') {
                timeHour = parseInt(timeState.hourValue, 10) + 12;
            }
            this.setState({ format24: 'false' });
        }
        this.setState((prevState) => {
            return {
                scheduleDateTimeObject: moment(prevState.scheduleDateTimeObject)
                    .hour(timeHour)
                    .minute(timeMinute),
            };
        });
    };

    handleDateChange = (e) => {
        if (e) {
            const year = moment(e)
                .format('YYYY');
            const month = parseInt(moment(e)
                .format('MM'), 10) - 1;
            const day = moment(e)
                .format('DD');
            this.setState((prevState) => {
                return {
                    scheduleDateTimeObject: moment(prevState.scheduleDateTimeObject)
                        .year(year)
                        .month(month)
                        .date(day),
                };
            });
        }
    };

    setNow = (scheduleBool) => {
        this.setState({ now: scheduleBool });
    };

    setStateFromEvent = (e, stateKey) => {
        const stateObj = {};
        stateObj[stateKey] = e.target.value;
        this.setState(stateObj);
    };

    handleCheckboxChange = (event) => {
        this.setState({ recipients: event.target.checked });
    };

    updateFormsSourceFromSelect = (val) => {
        if (val != null && val.value != null) {
            this.setState({
                formId: val.value,
                formLabel: val.label,
            });
        }
    };

    closeDialog() {
        if (this.props.close) {
            this.props.close();
        }
    }

    render() {
        const {
            Visible,
        } = this.props;

        return (
            <LargeModal title={this.props.messages && this.props.messages.id ? 'Edit Message' : 'New Message'} visible={Visible} close={this.closeDialog} class="message-modal" dataqa="messages-add-edit-modal">
                <div className="large-modal-scroll-wrapper">
                    <div className="message-modal-wrapper">
                        {this.state.message && this.state.title ? ''
                            : (
                                <h5 data-qa="messages-add-edit-modal-required" className="required-label">
                                    All Fields Required
                                </h5>
                            )}
                        <ValidatedInput
                            labelText="title"
                            charLimit={100}
                            name="title"
                            value={this.state.title ? this.state.title : this.props.messages.subject}
                            onChange={(e) => {
                                return this.setStateFromEvent(e, 'title');
                            }}
                            id="messages-add-edit-title-input"
                        />
                        <ValidatedInput
                            labelText="message"
                            charLimit={240}
                            name="message"
                            multiline
                            value={this.state.message ? this.state.message : this.props.messages.body}
                            onChange={(e) => {
                                return this.setStateFromEvent(e, 'message');
                            }}
                            id="messages-add-edit-message-input"
                        />
                        {this.props.flags.results && this.props.flags.results?.eventMessaging
                    && (
                        <div className="recipients">
                            {this.props.history && this.props.messages && this.props.messages.id
                                ? null
                                : (
                                    <div className="section-header">
                                        Message Recipients
                                    </div>
                                )}

                            {this.props.history && this.props.messages && this.props.messages.id
                                ? (
                                    <div className="sent-form">
                                        Sent To
                                        <span
                                            className="message-recipients"
                                        >
                                            {this.props.messages.formTitle ? this.props.messages.formTitle : i18n.t('messages.everyone')}
                                        </span>
                                    </div>
                                )
                                : (
                                    <div className="send-to check-rec">
                                        <label
                                            data-qa="sent-recipients-label"
                                            id="send-recipients__label"
                                        >
                                            <input
                                                data-qa="sent-recipients-checkbox"
                                                id="send-recipients"
                                                name="event-recipients"
                                                checked={this.state.recipients}
                                                onChange={this.handleCheckboxChange}
                                                type="checkbox"
                                            />
                                            <span
                                                className={`checkbox-rec ${this.state.recipients ? 'checked' : 'empty'}`}
                                            />
                                            <span>
                                                Send only to registrants of a particular event
                                            </span>
                                        </label>
                                    </div>
                                )}
                            {this.props.history && !this.props.messages.id && this.state.recipients
                        && (
                            <Select
                                id="featured-options"
                                options={this.props.forms}
                                className="form-selector"
                                classNamePrefix="form-selector"
                                value={this.props.forms.length > 0 ? this.props.forms.find((f) => { return f.value === this.state.formId; }) : ''}
                                onChange={this.updateFormsSourceFromSelect}
                                clearable={false}
                                disabled={this.props.forms.length === 0}
                                label={this.props.forms.length > 0 ? this.state.formLabel : ''}
                            />
                        )}
                            {!this.props.history && this.state.recipients
                        && (
                            <Select
                                id="featured-options"
                                options={this.props.forms}
                                className="form-selector"
                                classNamePrefix="form-selector"
                                value={this.props.forms.length > 0 ? this.props.forms.find((f) => { return f.value === this.state.formId; }) : ''}
                                onChange={this.updateFormsSourceFromSelect}
                                disabled={this.props.forms.length === 0}
                                label={this.props.forms.length > 0 ? this.state.formLabel : ''}
                            />
                        )}
                            {this.state.recipients && !this.state.formId
                        && (
                            <h5 data-qa="form-required" className="required-label">
                                A form must be selected.
                            </h5>
                        )}
                        </div>
                    )}
                        {this.props.history && this.props.messages && this.props.messages.id ? null
                            : (
                                <div className="section-header">
                                    Delivery Options
                                </div>
                            )}
                        {this.props.history && this.props.messages && this.props.messages.id
                            ? (
                                <div className="sent">
                                    Sent On
                                    <Calendar />
                                    <span
                                        className="message-date"
                                    >
                                        {moment(`${this.props.messages.scheduledTime}Z`)
                                            .utc()
                                            .tz(moment.tz.guess())
                                            .format('MMM DD YYYY')}
                                    </span>
                                    <Clock />
                                    <span
                                        className="message-time"
                                    >
                                        {moment(`${this.props.messages.scheduledTime}Z`)
                                            .utc()
                                            .tz(moment.tz.guess())
                                            .format('hh:mm A z')}
                                    </span>
                                </div>
                            ) : (
                                <div className="radio-wrapper">
                                    <div className="radio">
                                        <input
                                            data-qa="send-now-radio"
                                            id="send-now"
                                            type="radio"
                                            name="base-theme"
                                            checked={this.state.now}
                                            tabIndex="0"
                                            className="hidden"
                                            onClick={() => {
                                                return this.setNow(true);
                                            }}
                                        />
                                        <label data-qa="send-now-radio-label" id="send-now__label">
                                            Send Right Away
                                        </label>
                                    </div>
                                    <div className="radio">
                                        <input
                                            data-qa="send-scheduled-radio"
                                            id="schedule"
                                            type="radio"
                                            name="base-theme"
                                            checked={!this.state.now}
                                            tabIndex="0"
                                            className="hidden"
                                            onClick={() => {
                                                return this.setNow(false);
                                            }}
                                        />
                                        <label data-qa="send-scheduled-radio-label" id="schedule__label">
                                            Schedule For Later
                                        </label>
                                        {this.state.now
                                    || (this.props.history
                                        && this.props.messages
                                        && this.props.messages.id)
                                            ? null
                                            : (
                                                <div
                                                    className={`datetime-pickers ${this.state.timePastAlert ? 'alert-on' : ''}`}
                                                >
                                                    <div
                                                        data-qa="date-time-pickers"
                                                        id="date-picker"
                                                        className="date-picker"
                                                    >
                                                        <span className="calendar"><Calendar /></span>
                                                        <DatePicker
                                                            popperPlacement="bottom"
                                                            dateFormat="MM/dd/yyyy"
                                                            showYearDropdown
                                                            yearDropdownItemNumber={1}
                                                            minDate={moment()
                                                                .toDate()}
                                                            selected={
                                                                moment(
                                                                    this.state.scheduleDateTimeObject,
                                                                ).toDate()
                                                            }
                                                            onChange={this.handleDateChange}
                                                        />
                                                    </div>
                                                    <TimePicker
                                                        messages={
                                                            this.props.messages.scheduledTime
                                                                ? this.props.messages.scheduledTime
                                                                : moment(
                                                                    this.state.scheduleDateTimeObject,
                                                                )
                                                                    .utc()
                                                                    .format('YYYY-MM-DDTHH:mm')
                                                        }
                                                        format24={this.state.format24}
                                                        timeinputchange={this.handleTimeChange}
                                                        pickerDown={this.state.pickerDown}
                                                    />
                                                    {this.state.timePastAlert
                                        && (
                                            <div data-qa="time-alert" className="time-alert">
                                                Scheduled Time must be in future or&nbsp;
                                                &quot;Send Right Away&quot; must be selected
                                            </div>
                                        )}
                                                </div>
                                            )}
                                    </div>
                                </div>
                            )}
                        <div className="btn-wrap">
                            <div className="btn-link-wrap action-save">
                                {(this.state.message && this.state.title
                                && (!this.state.recipients
                                    || (this.state.recipients && this.state.formId))
                                && ((this.props.history && this.props.messages.id)
                                || (this.state.now
                                        || this.state.scheduleDateTimeObject.isAfter(moment()
                                            .subtract(1, 'minutes')))))
                                    ? (
                                // eslint-disable-next-line react/button-has-type
                                        <button
                                            data-qa="save-button"
                                            className="btn btn-secondary"
                                            onClick={this.executeSave}
                                        >
                                            {/* eslint-disable-next-line no-nested-ternary */}
                                            {this.props.messages && this.props.messages.id ? 'Save' : this.state.now ? 'Send Now' : 'Schedule'}
                                        </button>
                                    )
                                    : (
                                // eslint-disable-next-line react/button-has-type
                                        <button
                                            data-qa="save-button-disabled"
                                            className="btn btn-null"
                                            onClick={null}
                                        >
                                            {/* eslint-disable-next-line no-nested-ternary */}
                                            {this.props.messages && this.props.messages.id ? 'Save' : this.state.now ? 'Send Now' : 'Schedule'}
                                        </button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </LargeModal>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(null, mapDispatchToProps)(MessagesModal);
